registerComponent("pages/about", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ SEM CALL SITE DESDE 2023-11-23. O `.header-docs` que este acordeão governa
 * saiu do Blade no commit `779524f3` ("Working...", bloco `.wrap-colored` com os
 * documentos regulatórios), e desde então tanto este arquivo quanto as regras
 * `.wrap-colored`/`.header-docs` de `_about.less` são código morto: o
 * `querySelectorAll` abaixo devolve lista vazia em `/o-asa` e `/o-asa/escritorios`.
 * Checagens 1 (grep literal) e 2 (`git log -S`) do protocolo de remoção feitas no
 * sub-lote 6a e registradas no relatório; a remoção em si é da Fase 9.
 *
 * Transposto mesmo assim, porque a fase é de transposição e não de remoção: o
 * `slideUp`/`slideDown` do jQuery vira `max-height` em transição, que é a receita
 * do plano — `height: auto` não anima, e sem isso o acordeão abriria de estalo.
 */

const cabecalhos = component.querySelectorAll('.header-docs');

/**
 * Mede o conteúdo e devolve o `max-height` do estado aberto. O jQuery media o
 * `scrollHeight` a cada animação, e não uma vez: conteúdo que muda de altura
 * (imagem que carrega, fonte que troca) ficaria cortado com um valor fixo.
 *
 * @param {HTMLElement} painel
 * @returns {string}
 */
function alturaAberta(painel) {
    return `${painel.scrollHeight}px`;
}

cabecalhos.forEach(function (cabecalho) {
    const painel = cabecalho.nextElementSibling;

    if (!painel) {
        return;
    }

    /*
     | O markup de 2020 trazia `style="display: none"` no painel — era o que o
     | `slideDown` desfazia. Trocamos por `max-height: 0` mais `overflow: hidden`,
     | porque `display: none` não anima; o `display` sai aqui, no JS, e não no
     | LESS, para que sem JS o conteúdo continue visível (regra do programa).
     */
    painel.style.display = '';
    painel.style.overflow = 'hidden';
    painel.style.transition = 'max-height .3s ease';
    painel.style.maxHeight = cabecalho.classList.contains('expanded') ? alturaAberta(painel) : '0px';

    cabecalho.addEventListener('click', function () {
        const aberto = cabecalho.classList.contains('expanded');

        cabecalho.classList.toggle('expanded', !aberto);
        cabecalho.classList.toggle('retracted', aberto);

        painel.style.maxHeight = aberto ? '0px' : alturaAberta(painel);
    });
});

});
